import React from 'react'

export const AuthLayout = ({
    heading,
    title,
    children,
    footer,
}) => {
    return (
        <section className="auth_section">
            <div className='card_form_wrapper'>
                <div className='auth_heading'>
                    <img src="/images/logo-fill.png" alt="" />
                    <h1>{heading}</h1>
                    <p>{title}</p>

                </div>
                {children}

                {/* {footer} */}
            </div>
        </section>
    )
}
